import type { AgeBand } from '../types';

// Three-month development windows mirroring the KVS questionnaire AgeGroup enum,
// open-ended from 33 months. Used to label a planned observation by the child's
// current age before the backend assigns the questionnaire.
export const AGE_BANDS: ReadonlyArray<AgeBand> = [
  { label: '0-2', minMonths: 0, maxMonths: 2 },
  { label: '3-5', minMonths: 3, maxMonths: 5 },
  { label: '6-8', minMonths: 6, maxMonths: 8 },
  { label: '9-11', minMonths: 9, maxMonths: 11 },
  { label: '12-14', minMonths: 12, maxMonths: 14 },
  { label: '15-17', minMonths: 15, maxMonths: 17 },
  { label: '18-20', minMonths: 18, maxMonths: 20 },
  { label: '21-23', minMonths: 21, maxMonths: 23 },
  { label: '24-26', minMonths: 24, maxMonths: 26 },
  { label: '27-29', minMonths: 27, maxMonths: 29 },
  { label: '30-32', minMonths: 30, maxMonths: 32 },
  { label: '33+', minMonths: 33, maxMonths: null },
];
